import React, { Component } from "react";

export class NotFoundPage extends Component {
  render() {
    return (
      <div>
        <h1> Can not Find Page at the moment! </h1>
        <h3> The Page is under construction </h3>
      </div>
    );
  }
}

export default NotFoundPage;
